<template>
  <div class="_make-article ">
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">การเปลี่ยนไปเป็นแป้นพิมพ์ (Switch to keyboard)</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เป็น API ที่ใช้สำหรับเปลี่ยนรูปแบบของเมนูด้านล่างให้เป็นรูปแบบการรับค่าแบบแป้นพิมพ์(keyboard) เช่น ในกรณีที่ ผู้ใช้งานกดปุ่มBottom menu เรียบร้อยแล้ว และระบบต้องการให้ผู้ใช้งานพิมพ์ข้อความตอบกลับ</p>
    </div>

    <header class="EndpointHeader">
      <h2 class="EndpointTitle">
        API ส่งข้อความ
      </h2>
      -
      <span class="EndpointVerbPost">
        POST
      </span>
      <span class="EndpointUrl">
        {{urlswitch_keyboard}}
           <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlswitch_keyboard">file_copy</v-icon>
      </span>
    </header>

    <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON)</h3>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"user_id"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>user_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>user_id ที่ต้องการจะส่ง</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        
      </table>

      <br>
       <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbPost">
        200 OK
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง request มาถูกต้อง
      </span>
    </header>
<code class="codecolor">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageresponse">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>

      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
       
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสำเร็จ
          </td>
        </tr>
      </table>
    </div>
    <!-- mobile -->
    <div class="hidden-md-and-up">
      <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON)</h3>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"user_id"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>
  }
      </code>

     <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>user_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>user_id ที่ต้องการจะส่ง</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        
      </table>
      <br>

       <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbPost">
        200 OK
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง request มาถูกต้อง

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageresponse">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
 {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>

      <table id="apimsgtablemo" style="margin-top: 2vh;">
      <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสำเร็จ
          </td>
        </tr>
      </table>

  </div>
</div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    urlswitch_keyboard: '',
    message: '{\n\t"user_id": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"bot_id": "Ba521xx18350a5xxx2bxxxxx"\n}',
    messageresponse: '{\n\t"status": "success"\n}',
    headermessage: '{\n\t"header": "Bearer 0nTblsxxx"}'
  }),
  methods: {

  },
  created () {
    this.urlswitch_keyboard = process.env.APIalpine + '/api/v1/switchKeyboard'
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbfail {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid orange;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: orange;
    color: #FFFFFF;
}
.EndpointVerberror {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid red;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: red;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
.MarkdownContent {
      width: 75vw !important;
}


</style>





// WEBPACK FOOTER //
// src/components/home/api/reply/webhook_switch_keyboard.vue